module.exports = __webpack_public_path__ + "static/real-superfoods-31bd6df626001d23e273f4cd992fd608.svg";